import { calcAGDrating } from '@package/utils/src/rating';
import clsx from 'clsx';

import Image from 'next/image';
import Link from '../../Link';
import Rating from '../../Rating';
import config from 'config-base';
import styles from './TopSellingCard.module.css';
import { TopSellingCardProps } from './types';
import SearchResultsPrice from './components/SearchResultsPrice';

const TopSellingCard = ({
  searchItem,
  className,
  idx,
  imageClasses,
  priorityIndex = 2,
  onClick,
  onContextMenu,
}: TopSellingCardProps) => {
  const {
    imageId,
    linkId,
    name,
    newPriceMin,
    newPriceMax,
    newSalePriceMin,
    newSalePriceMax,
    numReviews,
    priceCents,
    pricePerUnit,
    pricePerUnitLabel,
    productConditionMax,
    rating,
    salePriceCents,
  } = searchItem;
  return (
    <div
      className={clsx(
        styles.searchItemContainer,
        { [styles.searchItemContainerAGD]: config.brandCode !== '0' },
        className,
      )}
    >
      <Link
        data-testid={'top-selling-card-link-card'}
        href={linkId}
        classes={clsx(styles.linkCard, {
          [styles.linkCardAGD]: config.brandCode !== '0',
        })}
        onClick={(ev: any) => {
          if (onClick) {
            ev.preventDefault();
            onClick(searchItem?.clickTrackingURL, linkId);
          }
        }}
        onContextMenu={() => {
          if (onContextMenu) {
            onContextMenu(searchItem?.clickTrackingURL);
          }
        }}
        showCursorPointer
      >
        <div className={styles.searchItemImageContainer}>
          <Image
            priority={priorityIndex === -1 ? false : idx <= priorityIndex}
            src={imageId}
            width={400}
            height={300}
            alt={name}
            className={clsx(styles.searchItemImage, imageClasses)}
          />
          {searchItem?.new && (
            <span className={styles.newImage}>
              <Image src={'/marketplace-static/images/new_icon.png'} layout="fill" alt="new" />
            </span>
          )}
          {salePriceCents > 0 && (
            <span className={styles.saleImage}>
              <Image src={'/marketplace-static/images/sale.svg'} layout="fill" alt="sale" />
            </span>
          )}
        </div>
        <Rating
          reviewers={numReviews || 0}
          defaultValue={calcAGDrating(rating) || 0}
          ratingContainerClasses={clsx(styles.rating, {
            [styles.ratingAGD]: config.brandCode !== '0',
          })}
          ratingTextClasses={clsx(styles.ratingText, {
            [styles.ratingTextAGD]: config.brandCode !== '0',
          })}
          hideRating={true}
        />
        <p className={clsx(styles.searchItemName, styles.nameClamp)}>{name}</p>
        <SearchResultsPrice
          pricePerUnit={pricePerUnit as string | undefined}
          priceCents={priceCents}
          salePriceCents={salePriceCents}
          pricePerUnitLabel={pricePerUnitLabel as string | undefined}
          NewPriceMax={newPriceMax as string | undefined}
          NewPriceMin={newPriceMin as string | undefined}
          NewSalePriceMax={newSalePriceMax as string | undefined}
          NewSalePriceMin={newSalePriceMin as string | undefined}
          ProductConditionMax={productConditionMax as string | undefined}
        />
      </Link>
    </div>
  );
};

export default TopSellingCard;
